import { ColorSchemeDefinition, ThemeProvider } from "@elit-hair/elit-ui";

import { SnowfallEffect } from "@/components/ui/snowfall-effect";
import { useSettings } from "@/providers/general/settings-provider";
import winterWonderlandCssUrl from "@/styles/themes/winter-wonderland.css?url";

export const extraThemes: ColorSchemeDefinition[] = [
    {
        value: "winter-wonderland",
        label: "Winter Wonderland",
        cssFile: winterWonderlandCssUrl,
    },
];

export function ThemeProviderWrapper({ children }: { children: React.ReactNode }) {
    const { currentSettings } = useSettings();

    return (
        <ThemeProvider
            extraThemes={extraThemes}
            initialTheme={currentSettings.THEME}
            initialColorScheme={currentSettings.COLOR_SCHEME}
        >
            {currentSettings.COLOR_SCHEME === extraThemes[0].value && <SnowfallEffect />}
            {children}
        </ThemeProvider>
    );
}
